(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fatio-christmas-categories"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fatio-christmas-nav')) {
 customElements.define('fatio-christmas-nav',class extends HTMLElement {
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();
   this.addEventListener('click',event=>{
    const link=event.target.closest('a[data-fx-target]');
    if(!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey || event.button !== 0)return;
    const target=document.getElementById(link.dataset.fxTarget);
    if(target){event.preventDefault();target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});}
   },{signal:this.abort.signal});
  }
  disconnectedCallback(){this.abort?.abort();}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fatio-christmas-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fatio-christmas-grid')) {
    let cartQueue = Promise.resolve();
    customElements.define('fatio-christmas-grid', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.addEventListener('submit', event => {
          const form = event.target.closest('form.fx-product-form');
          if (!form || !this.contains(form)) return;
          event.preventDefault();
          event.stopPropagation();
          if (form.dataset.pending === 'true') return;
          const button = form.querySelector('button[type="submit"]');
          const label = button.querySelector('.fx-add-label');
          const message = form.querySelector('.fx-cart-message');
          const original = label.dataset.defaultLabel || label.textContent;
          label.dataset.defaultLabel = original;
          form.dataset.pending = 'true';
          button.disabled = true;
          button.setAttribute('aria-busy', 'true');
          label.textContent = this.dataset.addingLabel;
          message.textContent = '';
          message.removeAttribute('data-error');
          cartQueue = cartQueue.catch(() => {}).then(async () => {
            try {
              const root = window.Shopify?.routes?.root || '/';
              const data = new FormData(form);
              const body = {
                id: data.get('id'),
                quantity: Number(data.get('quantity')) || 1,
                sections_url: window.location.pathname
              };
              if (document.getElementById('form-mini-cart')) body.sections = ['form-mini-cart'];
              const response = await fetch(root + 'cart/add.js', {
                method: 'POST',
                credentials: 'same-origin',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                body: JSON.stringify(body)
              });
              const result = await response.json();
              if (!response.ok || result.status || result.errors) {
                const detail = typeof result.description === 'string' ? result.description : '';
                throw new Error(detail || this.dataset.errorLabel);
              }
              await this.refreshCart(root, result).catch(() => {});
              message.textContent = this.dataset.addedLabel;
              label.textContent = this.dataset.addedLabel;
              window.setTimeout(() => {
                if (label.isConnected && form.dataset.pending !== 'true') label.textContent = original;
              }, 1800);
            } catch (error) {
              message.textContent = error.message || this.dataset.errorLabel;
              message.setAttribute('data-error', '');
              label.textContent = original;
            } finally {
              form.dataset.pending = 'false';
              button.disabled = false;
              button.removeAttribute('aria-busy');
            }
          });
        }, { capture: true, signal: this.abort.signal });
      }
      async refreshCart(root, result) {
        let miniCartHtml = result.sections?.['form-mini-cart'];
        if (!miniCartHtml && document.getElementById('form-mini-cart')) {
          try {
            const sectionUrl = new URL(window.location.pathname, window.location.origin);
            sectionUrl.searchParams.set('sections', 'form-mini-cart');
            const response = await fetch(sectionUrl, { credentials: 'same-origin' });
            if (response.ok) miniCartHtml = (await response.json())['form-mini-cart'];
          } catch {}
        }
        if (miniCartHtml) {
          const parsed = new DOMParser().parseFromString(miniCartHtml, 'text/html');
          const current = document.getElementById('form-mini-cart');
          const next = parsed.getElementById('form-mini-cart');
          if (current && next) {
            current.innerHTML = next.innerHTML;
            const notification = document.querySelector('cart-notification');
            if (notification) {
              notification.classList.remove('is-empty');
              if (typeof notification.cartAction === 'function') notification.cartAction();
              if (typeof notification.addonsUpdate === 'function') notification.addonsUpdate();
            }
          }
        }
        const response = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (typeof cart.item_count !== 'number') return;
        document.querySelectorAll('.cart-count').forEach(element => {
          element.textContent = element.classList.contains('cart-count-drawer') ? `(${cart.item_count})` : String(cart.item_count);
        });
        const total = document.querySelector('header-total-price');
        if (typeof total?.updateTotal === 'function') total.updateTotal(cart);
        const shipping = document.querySelector('free-ship-progress-bar');
        if (typeof shipping?.init === 'function') shipping.init(cart.items_subtotal_price);
        const notification = document.querySelector('cart-notification');
        if (notification) notification.currentItemCount = cart.item_count;
        document.dispatchEvent(new CustomEvent('fatio:cart-updated', { detail: { cart } }));
      }
      disconnectedCallback() {
        this.abort?.abort();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fatio-christmas-hero"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fatio-christmas')) {
    customElements.define('fatio-christmas', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.motion = this.querySelector('.fx-motion');
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => {
          this.motion.hidden = this.dataset.animate !== 'true' || this.preference.matches;
          this.toggleAttribute('data-paused', this.preference.matches || this.userPaused === true);
          this.motion.setAttribute('aria-pressed', String(this.userPaused === true));
          this.motion.textContent = this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        };
        this.motion.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          update();
        }, { signal: this.abort.signal });
        this.preference.addEventListener('change', update, { signal: this.abort.signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
          });
          this.observer.observe(this.querySelector('.fx-hero'));
        }
        update();
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fatio-christmas"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fatio-christmas')) {
    customElements.define('fatio-christmas', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.motion = this.querySelector('.fx-motion');
        this.preference = window.matchMedia('(prefers-reduced-motion: reduce)');
        const update = () => {
          this.motion.hidden = this.dataset.animate !== 'true' || this.preference.matches;
          this.toggleAttribute('data-paused', this.preference.matches || this.userPaused === true);
          this.motion.setAttribute('aria-pressed', String(this.userPaused === true));
          this.motion.textContent = this.userPaused ? this.dataset.resumeLabel : this.dataset.pauseLabel;
        };
        this.motion.addEventListener('click', () => {
          this.userPaused = !this.userPaused;
          update();
        }, { signal: this.abort.signal });
        this.preference.addEventListener('change', update, { signal: this.abort.signal });
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(entries => {
            this.toggleAttribute('data-offscreen', !entries[0].isIntersecting);
          });
          this.observer.observe(this.querySelector('.fx-hero'));
        }
        update();
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fatio-sale-product-grid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fatio-sale-grid')) {
    customElements.define(
      'fatio-sale-grid',
      class extends HTMLElement {
        connectedCallback() {
          if (this.saleController) return;

          this.saleController = new AbortController();

          const button = this.querySelector('[data-sale-more]');
          if (!button) return;

          button.addEventListener(
            'click',
            () => {
              const step = Math.max(
                1,
                Number(this.dataset.step) || 1
              );

              const hiddenCards = [
                ...this.querySelectorAll('.fatio-sale-card[hidden]')
              ];

              hiddenCards.slice(0, step).forEach((card) => {
                card.hidden = false;
              });

              if (hiddenCards.length <= step) {
                button.closest('[data-sale-more-wrap]').hidden = true;
              }
            },
            { signal: this.saleController.signal }
          );
        }

        disconnectedCallback() {
          this.saleController?.abort();
          this.saleController = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
